import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { Config } from 'shared/config/env.config';
import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import { DIGITAL_ASSETS } from 'shared/search/search-service-types';

@Injectable()
export class DigitalAssetsSearchService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();
  serviceType = DIGITAL_ASSETS;
  idField = 'origin_id';

  statusLookup: Array<any> = [
    { id: 0, status: 'Unassigned'},
    { id: 1, status: 'Assigned'},
    // { id: 2, status: 'Unassigned & Not Uploaded'},
    { id: 3, status: 'Not uploaded'},
  ];

  getSearchURI(brandId: string, searchModel: SearchModel): string {
    return `/assets/${brandId}/working`;
  }

  getQueryString(searchModel: SearchModel): string {
    const assigned: string = (searchModel.statusModel) ? searchModel.statusModel.id.toString() : '';
    const sortCol: string = (searchModel.sortModel) ? searchModel.sortModel.column : '';
    const sortDir: string = (searchModel.sortModel) ? searchModel.sortModel.sort : '';

    const queryString: string =
      'page=' + searchModel.currentPage +
      '&itemsPerPage=' + searchModel.itemsPerPage +
      '&search=' + searchModel.searchValue +
      '&list=' + this.listFilterId +
      '&assigned=' + (assigned !== 'all' ? assigned : '') +
      '&sortCol=' + sortCol +
      '&sortDir=' + sortDir;

    return queryString;
  }

}
